import { fetchAuthSession } from 'aws-amplify/auth'

export async function getAuthorizationToken() {
  try {
    const session = await fetchAuthSession()
    const token = session.tokens?.idToken?.toString()
    if (token) {
      return token
    }
  } catch {
    // no Cognito session
  }

  return localStorage.getItem('secureToken')
}
